// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2rBmJ","bigColWidth":"Table_bigColWidth__2Y7Wy","biggerColWidth":"Table_biggerColWidth__1i69b","row":"Table_row__1HhWD","col":"Table_col__2Ty-Y"};